var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPProgressIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 20.0001C15.5229 20.0001 20.0001 15.5229 20.0001 10.0001C20.0001 4.47724 15.5229 9.15527e-05 10.0001 9.15527e-05C4.47721 9.15527e-05 6.10352e-05 4.47724 6.10352e-05 10.0001C6.10352e-05 15.5229 4.47721 20.0001 10.0001 20.0001ZM16.0001 10.0001C16.0001 13.3138 13.3138 16.0001 10.0001 16.0001V4.00009C13.3138 4.00009 16.0001 6.68638 16.0001 10.0001Z",
    fill: "#F2AE40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPProgressIcon);
export default __webpack_public_path__ + "static/media/p-progress-icon.25eebecb924b99686dc41c5950fbe970.svg";
export { ForwardRef as ReactComponent };